export const ink = {
  50: '#E6E6E6',
  100: '#BFBFBF',
  200: '#959595',
  300: '#6B6B6B',
  400: '#4B4B4B',
  500: '#2B2B2B',
  600: '#262626',
  700: '#202020',
  800: '#1A1A1A',
  900: '#101010'
};

export const teal = {
  50: '#E4F3F3',
  100: '#BBE1E2',
  200: '#BDCDCE',
  300: '#5FB8BA',
  400: '#3DA9AC',
  500: '#1B9A9D',
  600: '#189295',
  700: '#14888B',
  800: '#107E81',
  900: '#086C6F',
  default: '#0382aa'
};

export const yellow = {
  100: '#FFF5B3',
  900: '#FFC500'
};

export const gray = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
};

export const colors = {
  black: '#000',
  chalk: '#fff',
  heather: '#f4f4f4',
  dove: '#ccc',
  slate: '#4b4b4b',
  ink: ink[500],
  ash: '#727272',
  cloud: '#999999',
  teal: teal[500],
  grape: '#6227a3',
  cobalt: '#0074ad',
  apple: '#00960f',
  apricot: '#ff8c04',
  scarlet: {
    default: '#da1b1b',
    light: '#fff1f1',
    dark: '#af1515',
  },
  arctic: '#e5f1f7',
  mint: '#e5f4e7',
  peach: '#f3f3e5',
  'dusty-rose': '#fbe8e8',
};

export const alerts = {
  info: {
    loud: colors.cobalt,
    quiet: colors.arctic
  },
  success: {
    loud: colors.apple,
    quiet: colors.mint
  },
  warning: {
    loud: colors.apricot,
    quiet: colors.peach
  },
  error: {
    loud: colors.scarlet.default,
    quiet: colors['dusty-rose']
  },
  grappa: {
    quiet: '#E7DFF1'
  }
};

export const borderRadius = {
  sm: '4px',
  md: '16px',
  full: '9999px'
};


